import { FunctionComponent, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { IMembersSearchResultsItem } from 'Frontend/scripts/models/members.model'
import { deleteUser } from 'Frontend/scripts/services/users.service'
import { Button } from 'react-bootstrap'
import Dialog from 'Features/Dialog/Dialog'

interface DeleteUserProps {
  user: IMembersSearchResultsItem
  callback: () => void
}
const DeleteUser: FunctionComponent<DeleteUserProps> = ({ user, callback }) => {
  const { t } = useTranslation()
  const [isDeleteUserDialogOpen, setIsDeleteUserDialogOpen] = useState<boolean>(false)

  const removeUser = () => {
    user?.id &&
      deleteUser(user?.id).then((isDeletedSuccessfully) => {
        if (isDeletedSuccessfully) {
          setIsDeleteUserDialogOpen(false)
          callback()
        }
      })
  }

  return (
    <>
      <li className="d-flex justify-content-between manage-forums__thread-item">
        <a href={user.viewProfileUrl} className="manage-forums__thread-item-link">
          {user?.firstname}&nbsp;
          {user?.lastname}
        </a>
        <Button variant="dark" size="sm" onClick={() => setIsDeleteUserDialogOpen(true)}>
          {t('dashboard.delete-users.delete')}
        </Button>
        <Dialog
          isOpen={isDeleteUserDialogOpen}
          verificationText={t('dashboard.delete-users.verification-delete')}
          submitText={t('dashboard.delete-users.yes-delete-user')}
          abortText={t('abort')}
          buttonVariant="dark"
          callbackSubmit={() => {
            removeUser()
          }}
          callbackClose={() => {
            setIsDeleteUserDialogOpen(false)
          }}
        />
      </li>
    </>
  )
}

export default DeleteUser
